import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectInfiniteScrollModule } from 'ng-mat-select-infinite-scroll';
import { Ng2TelInputModule } from 'ng2-tel-input';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CoreModule } from '../../core/core.module';
import { LoaderModule } from '../../shared/directives/loader/loader.module';
import { SharedModule } from '../../shared/shared.module';
import { CarrierPopupComponent } from './components/carriers-list/carrier-popup/carrier-popup.component';
import { CarrierNamePopupComponent } from './components/carriers-list/carrier-name-popup/carrier-name-popup.component';
import { CarriersListComponent } from './components/carriers-list/carriers-list.component';
import { CoverageMapComponent } from './components/coverage-map/coverage-map.component';
import { CoverageMapPopupComponent } from './components/coverage-map/coverage-map-popup/coverage-map-popup.component';
import { CarriersRoutingModule } from './carriers-routing.module';
import { ShipmentPriceModule } from '../shipment-price/shipment-price.module';
import { UploadFileService } from '../../core/services/upload-file.service';

@NgModule({
    declarations: [
        CarriersListComponent,
        CarrierPopupComponent,
        CarrierNamePopupComponent,
        CoverageMapComponent,
        CoverageMapPopupComponent,
    ],
    imports: [
        CommonModule,
        CarriersRoutingModule,
        MatTabsModule,
        MatCardModule,
        CoreModule,
        MatTableModule,
        MatSortModule,
        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatInputModule,
        SharedModule,
        Ng2TelInputModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatMenuModule,
        MatCheckboxModule,
        MatTooltipModule,
        MatSelectInfiniteScrollModule,
        LoaderModule,
        FormsModule,
        MatDatepickerModule,
        NgxMatSelectSearchModule,
        MatListModule,
        ShipmentPriceModule,
    ],
    providers: [
        UploadFileService,
    ],
    exports: [
        CarrierPopupComponent,
    ],
})
export class CarriersModule { }
